import Swal from 'sweetalert2'

export function showSuccessAlert({ position = 'top-end', title, text, timer = 4500 }){
    return Swal.fire({
        icon: 'success',
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showWarningAlert({ position = 'top-end', title, text, timer = 4500 }){
    return Swal.fire({
        icon: 'warning',
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showErrorAlert({ position = 'top-end', title, text, timer = 4500 }){
    return Swal.fire({
        icon: 'error',
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showInfoAlert({ position = 'top-end', title, text, timer = 4500 }){
    return Swal.fire({
        icon: 'info',
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showAlert({ icon = 'info', position = 'top-end', title = '', text = '', timer = 4500 }){
    return Swal.fire({
        icon,
        position,
        title,
        text,
        showConfirmButton: false,
        timer
    })
}

export function showConfirmAlert({ title, text, icon = 'warning', confirmButtonText = 'Sí, confirmar!', cancelButtonText = 'Cancelar',
    confirmButtonColor = '#3085d6', cancelButtonColor = '#d33'
}) {
    return Swal.fire({
        icon,
        title,
        text,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        confirmButtonColor,
        cancelButtonColor
    });
}